import { capitalize, words } from 'lodash';

/**
 * The title-casing `SMLButton` applies to a plain-string label ("publish" → "Publish"). Shared so
 * a control that stands in for an `SMLButton` — a locked control replacing it, say — reads the
 * label the same way in both states.
 *
 * Title Case is an English habit only. Another language keeps its label as written: it gave
 * "Encontrar Os Outros Links" in Portuguese (QA 2026-10-28, litr2-3). With no locale the label
 * counts as English.
 */
export function titleCaseLabel(label: string, locale: string = 'en'): string {
  if (!locale.toLowerCase().startsWith('en')) {
    return label;
  }
  return words(label).map(capitalize).join(' ');
}
